import axios from 'axios';
import { config } from '@/config';
import { useAuthStore } from '@/features/auth/store';
/**
 * Pre-configured axios instance.
 * All API calls should use this instance, not the raw axios default.
 *
 * Interceptors:
 *  - Request: attaches CONNECT accessToken as Authorization: Bearer <token>
 *  - Response: clears auth and redirects to /login on 401
 */
export const apiClient = axios.create({
    baseURL: config.apiBaseUrl,
    timeout: 15_000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});
// Request interceptor — attach CONNECT access token from auth store
apiClient.interceptors.request.use((requestConfig) => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
}, (error) => Promise.reject(error));
// Response interceptor — clear auth and redirect on 401 (token expired or invalid)
apiClient.interceptors.response.use((response) => response, (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
        useAuthStore.getState().clearAuth();
        window.location.replace('/login');
    }
    return Promise.reject(error);
});
